module.exports = __webpack_public_path__ + "media/sfx_die.629d572e.wav";